import React from 'react'
import brandCase1 from '../../../../../imges/intro/brandcase1.png'
import brandCase2 from '../../../../../imges/intro/brandcase2.png'
import './index.less'

function BrandCase() {
  const arr = [
    {
      url: brandCase1,
      title: '瑜大公子',
      tips: [
        '2月27日，热爱女神节点，赞数100W+，累计观看973.2W，GMV2.12亿',
        '6月13日，瑜你亿起 大有所为，点赞数100W+，累计观看1340W，GMV1.22亿',
        '8月13日，1314两周年盛典，点赞数100W+，累计观看人数1512W，GMV1.21亿',
      ],
    },
    {
      url: brandCase2,
      title: '李宣卓（酒仙）',
      tips: [
        '6月11日，破亿之约，格局之战。点赞数100W+，累计观看940W+，GMV1.03亿，单个酒水组合品突破1680万',
        '9月9日，两周年99巅峰夜。单场GMV突破4900W',
        '10月24日，首战双11，年度大促。单场GMV突破4698W',
      ],
    },
  ]
  return (
    <div className='pc-brand-case-wrapper'>
      <div className='brand-case-title'>
        品牌案例
      </div>
      <div className="cases-list">
        {arr.map((item, index) => {
          const { url, title, tips } = item

          return (
            <div className="cases-item" key={index}>
              <img className="image" src={url} alt={title} />

              <div className="title">{title}</div>
              <ul className="tips-wrapper">
                {tips.map((i, index) => (
                  <li className="tips-item" key={`li_${index}`}>{i}</li>
                ))}
              </ul>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default BrandCase
